import 'normalize.css/normalize.css'
import 'reset.css/reset.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue2-datepicker/index.css'
import '@/main.scss'
